import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import FeedPosts from 'src/app/organisms/Homepage/FeedPosts/FeedPosts';
import HomepageFeedTextBlock from 'src/app/organisms/Homepage/FeedTextBlock/FeedTextBlock';

const Feed = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-none']}
    paddingSm={['spacing-4xl', 'spacing-none']}
  >
    <Grid
      padding={['spacing-none', 'spacing-4xl']}
      paddingSm={['spacing-none', 'spacing-xl']}
      gap='spacing-7xl'
      gapXl='spacing-3xl'
    >
      <Stack
        justify='flex-start'
        align='flex-start'
        columns={5}
        columnsXl={12}
      >
        <HomepageFeedTextBlock />
      </Stack>
      <Stack
        columns={7}
        columnsXl={12}
      >
        <FeedPosts />
      </Stack>
    </Grid>
  </SectionLayout>
);

export default Feed;
